<template>
  <el-dialog :title="$t('productCategory.addTitle')" :visible.sync="dialogVisible" width="50%" @close="closeDialog">
    <el-form ref="form" :model="formData" label-width="120px">
      <el-form-item :label="$t('productCategory.categoryName')" prop="categoryName" :rules="[
        { required: true, message: $t('productCategory.nameRequired'), trigger: 'blur' },
        { max: 100, message: $t('productCategory.nameMaxLength'), trigger: 'blur' }
      ]">
        <el-input v-model="formData.categoryName" :placeholder="$t('productCategory.namePlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('productCategory.showOrder')" prop="seq" :rules="[
        { required: true, message: $t('productCategory.orderRequired'), trigger: 'blur' },
        { type: 'number', message: $t('productCategory.orderNumber'), trigger: 'blur' }
      ]">
        <el-input v-model.number="formData.seq" :placeholder="$t('productCategory.orderPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('productCategory.isShow')" prop="isShow" :rules="[
        { required: true, message: $t('productCategory.showRequired'), trigger: 'change' }
      ]">
        <el-select v-model="formData.isShow" :placeholder="$t('productCategory.showPlaceholder')" style="width:100%">
          <el-option v-for="(item, index) in isShows" :key="index" :label="item.name" :value="item.statusCd" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('productCategory.groupType')" prop="cateType" :rules="[
        { required: true, message: $t('productCategory.groupRequired'), trigger: 'change' }
      ]">
        <el-select v-model="formData.cateType" :placeholder="$t('productCategory.groupPlaceholder')" style="width:100%">
          <el-option v-for="(item, index) in cateTypes" :key="index" :label="item.name" :value="item.statusCd" />
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveProductCategory">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { saveProductCategory } from '@/api/goods/productCategoryApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddProductCategory',
  data() {
    return {
      dialogVisible: false,
      formData: {
        categoryName: '',
        seq: '',
        isShow: '',
        cateType: '',
        categoryLevel: '1',
        shopId: ''
      },
      isShows: [],
      cateTypes: []
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.getDictData()
    },
    async getDictData() {
      try {
        const { data } = await getDict('product_category', 'is_show')
        this.isShows = data
        const { data: cateTypes } = await getDict('product_category', 'cate_type')
        this.cateTypes = cateTypes
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    closeDialog() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
    },
    async saveProductCategory() {
      try {
        await this.$refs.form.validate()
        let shopId = getShopId()
        this.formData.shopId = shopId
        await saveProductCategory(this.formData)
        this.$emit('refresh')
        this.$message.success(this.$t('common.addSuccess'))
        this.closeDialog()
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error(error)

      }
    }
  }
}
</script>